import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Create from '../views/Create.vue'
import Login from '../views/Login.vue';
import List from '../views/List.vue';
import Admin from '../views/Admin.vue';
import Insights from '../views/Insights.vue';
import Amazon from '../views/Amazon.vue';
import PendingActionConfirm from '../views/PendingActionConfirm.vue';
    

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: "/list"
  },
  {
    path: "/create",
    name: "create",
    component: Create
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/list",
    name: "list",
    component: List
  },
  {
    path: "/insights",
    name: "insights",
    component: Insights
  },
  {
    path: "/amazon",
    name: "amazon",
    component: Amazon
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin
  },
  {
    path: "/actions/confirm/:token",
    name: "pending-action-confirm",
    component: PendingActionConfirm
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
